export const UPDATE_SELECTED_CHAMPION = "UPDATE_SELECTED_CHAMPION";
export const UPDATE_SELECTED_ABILITY = "UPDATE_SELECTED_ABILITY";
export const UPDATE_HOVERED_CHAMPION = "UPDATE_HOVERED_CHAMPION";
